module.exports = __webpack_public_path__ + "static/media/dogontv.aadb7e4c.jpg";